import { resolveText } from '../../i18n/resolveText';
export function renderHero(block) {
    const header = document.createElement('header');
    header.className = 'hero';
    header.innerHTML = `
    <img class="hero__photo" src="${block.photo}" alt="${resolveText(block.photoAlt)}">
    <div class="hero__gradient" aria-hidden="true"></div>
    <div class="hero__content">
      <img class="hero__logo" src="${block.logo}" alt="${resolveText(block.logoAlt)}">
      <div class="hero__text">
        <h1 class="hero__title">${resolveText(block.title)}</h1>
        <p class="hero__subtitle">${resolveText(block.subtitle)}</p>
      </div>
    </div>
  `;
    return header;
}
